import type { SocialAuthProvider } from "@pax/api-contract/client-config";
import { authClient } from "@/lib/auth-client";

export async function signInWithProvider(options: {
  provider: SocialAuthProvider;
  callbackURL: string;
  errorCallbackURL: string;
}): Promise<void> {
  const { error } = await authClient.signIn.social(options);
  if (error) throw new Error(error.message || "Sign-in could not start. Please try again.");
}

export async function linkProvider(options: {
  provider: SocialAuthProvider;
  callbackURL: string;
  errorCallbackURL: string;
}): Promise<void> {
  const { error } = await authClient.linkSocial(options);
  if (error)
    throw new Error(error.message || "Account connection could not start. Please try again.");
}
